import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks';
import { ConfigZigbeeNode } from '../components/ConfigZigbeeNode';
import { fetchZigbeeDeviceInfo } from '../actions/FetchZigbeeDeviceInfo';
export const ConfigZigbeeDevice = () => {
    const { id } = useParams();
    const node_id = Number(id);
    const zigbee_nodes = useAppSelector(state => state.definitions.zigbee_nodes);
    const zigbee_node = zigbee_nodes[node_id];
    const dispatch = useAppDispatch();
    let page;
    if (zigbee_node)
        page = (_jsx(ConfigZigbeeNode, { node_id: zigbee_node.id }));
    else
        page = '';
    useEffect(() => {
        if (zigbee_node) {
            dispatch(fetchZigbeeDeviceInfo(zigbee_node.id));
        }
    }, [zigbee_nodes]);
    return (_jsxs("div", { className: "page-container", children: [_jsx("h1", { children: "Zigbee node" }), page] }));
};
